module.exports = __webpack_public_path__ + "img/logoAndroidPhone.38f9def8.svg";